import { ENDPOINT } from "../configs/api";
import { ClassDetails, ClassItemProps } from "../types/class";
import { RequestResponse } from "../types/httpClient";
import { httpClient } from "./httpClient";

export async function getTeacherClassList(): Promise<ClassItemProps[]> {
    const response: RequestResponse = await httpClient.get(ENDPOINT.iclass.teacherClassList)
    return response.data.results || []
}

export async function getTeacherClassDetails(classId: number, system: string): Promise<ClassDetails | null> {
    const response: RequestResponse = await httpClient.get(`${ENDPOINT.iclass.teacherClassDetails}/${classId}`, {
        headers: {
            'X-System': system
        }
    })
    
    if (response.data.code > 0) {
        return null
    }

    return response.data.results
}

export async function getStudentClassDetails(): Promise<ClassDetails | null> {
    const response: RequestResponse = await httpClient.get(ENDPOINT.iclass.studentClassDetails)
    if (response.data.code > 0) {
        return null
    }

    return response.data.results
}